import { apiRequest } from '@/shared/api/client'

export interface FansLeaderboardPositionResponse {
  rank?: number
  rank_change_daily?: number
  tasks_success_count?: number
  arena_points?: number
  total?: number
  total_views?: number
}

function getHttpStatus(error: unknown): number | undefined {
  return (
    (error as { status?: number })?.status ??
    (error as { response?: { status?: number } })?.response?.status
  )
}

export async function getFansLeaderboardPosition(params: {
  sportType?: string
  clubId?: string
}): Promise<FansLeaderboardPositionResponse> {
  try {
    return await apiRequest<FansLeaderboardPositionResponse>({
      path: '/api/v2/leaderboards/fans/position',
      method: 'GET',
      query: {
        ...(params.sportType ? { sport_type: params.sportType } : {}),
        ...(params.clubId ? { club_id: params.clubId } : {})
      },
      format: 'json'
    })
  } catch (error) {
    // Route may not be deployed yet, or the fan has no row in this scope.
    const status = getHttpStatus(error)
    if (status === 404) {
      return {}
    }
    throw error
  }
}
